<template>
    <select
        class="form-control"
        name="recurrence-option"
        aria-label="Opção de recorrência"
        required
        @change="onInput"
        :value="value"
    >
        <option
            v-for="option in options"
            :key="option.id"
            :value="option.id"
        >
            {{ option.label }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'CartRecurrenceOptions',
    props: {
        value: {
            type: Number,
            description: 'Id da opção selecionada',
        },
        options: {
            type: Array,
            required: true,
            description: 'Opções de recorrencia',
        },
    },
    methods: {
        onInput({ target }) {
            const selected = this.options[target.options.selectedIndex];
            this.$emit('select', selected);
        },
    },
};
</script>
